import { render, staticRenderFns } from "./upcoming-class-card.vue?vue&type=template&id=1bad9a3c"
import script from "./upcoming-class-card.vue?vue&type=script&lang=js"
export * from "./upcoming-class-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports